






import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { ImpersonationError } from "@/employee/route-names";
import * as datadog from "@/shared/datadog";
import { CognitoTokens } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useImpersonatorStore } from "@/shared/store/impersonator";

@Component({
  components: {
    GenericLoadingSpinner
  }
})

export default class InitiateImpersonation extends Vue {
  userStore = useUserStore();
  impersonatorStore = useImpersonatorStore();

  @Prop()
  token: string;

  mounted () {
    if (this.userStore.loggedIn) {
      this.userStore.logoutForImpersonation();
    }

    this.impersonatorStore.setImpersonationStarting(true);

    if (this.token) {
      this.impersonatorStore.retrieveInitiateResponse(this.token);
    } else {
      const message = "Error in impersonation initiation";
      datadog.log(message, { fullPath: this.$route.fullPath }, "error");
      this.$router.push({ name: ImpersonationError });
    }
  }

  @Watch("impersonatorStore.initiateResponseLoaded")
  watchInitiateResponseLoaded () {
    if (!this.impersonatorStore.initiateResponseLoaded) {
      return;
    }

    const model: CognitoTokens = {
      email: null,
      username: this.impersonatorStore.impersonationInitiateData.cognitoUsername,
      accessToken: this.impersonatorStore.impersonationInitiateData.accessToken,
      idToken: this.impersonatorStore.impersonationInitiateData.idToken,
      refreshToken: this.impersonatorStore.impersonationInitiateData.refreshToken
    };

    this.impersonatorStore.setTokens(model)
        .then(() =>
            this.impersonatorStore.startPartnerImpersonation({
              impersonationInfo: this.impersonatorStore.impersonationInitiateData.impersonationInfo,
              isEmployeePortal: true,
              router: this.$router,
              forcePageReload: false
            } as any))
        .catch(() => {
          this.$router.push({ name: ImpersonationError });
        });
  }
}
